import React, { useState, useEffect } from "react";
import "./css/SideMenu.css";
import logo from "./img/logo.png";
import axios from 'axios';
import config from "../config"; // Импортируем API_URL


const SideMenu = ({ setActivePage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await axios.get(`${config.API_URL}/user_info`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Роль пользователя:", response.data.role); //  Лог для проверки
        setRole(response.data.role);
      } catch (error) {
        console.error("Ошибка загрузки роли пользователя:", error);
      }
    };

    fetchUserRole();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token'); // Удаляем токен
    window.location.reload(); // Перезагружаем страницу для выхода
  };
  return (
    <>
      <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      <nav className={`side-menu ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setIsOpen(false)}>✖</button>
        <ul>
          <li><a className="sliding-text" onClick={() => setActivePage("home")}>Главная</a></li>
          <li><a className="sliding-text" onClick={() => setActivePage("profile")}>Профиль</a></li>
          <li><a className="sliding-text" onClick={() => setActivePage("schedule")}>Расписание</a></li>
          <li><a className="sliding-text" onClick={() => setActivePage("chat")}>Чат</a></li>
          
          {role === "admin" || role === "moderator" ? (
            <li><a className="sliding-text" onClick={() => setActivePage("admin")}>Админ-панель</a></li>
          ) : null}
          {role === "leader"  && (
            <li><a className="sliding-text" onClick={() => setActivePage("leader")}>Меню старосты</a></li>
          )}

          <li><a className="sliding-text" onClick={handleLogout}>Выход</a></li>
        </ul>
        <span className="logo-text">ficus - make it simple</span>
        <img src={logo} alt='Ficus' className='logo'></img>
      </nav>
    </>
  );
};

export default SideMenu;
